export default __webpack_public_path__ + "static/day-9-66526a1bdfbde9188a3f0376b5963770.gif";